import { open, seal } from './vault.ts';

/**
 * Der Vault Key lebt ausschließlich hier im Speicher — nie in IndexedDB, nie im
 * localStorage. Sperren heißt: dieses Modul vergisst ihn, und alles Verschlüsselte
 * bleibt bis zur nächsten Eingabe der Passphrase unlesbar.
 */
let vaultKey: Uint8Array | null = null;

export function setVaultKey(key: Uint8Array): void {
  vaultKey = key;
}

export function clearVaultKey(): void {
  vaultKey?.fill(0);
  vaultKey = null;
}

export function isUnlocked(): boolean {
  return vaultKey !== null;
}

function requireVaultKey(): Uint8Array {
  if (!vaultKey) throw new Error('Vault ist gesperrt');
  return vaultKey;
}

/**
 * Führt etwas mit dem Vault Key aus, ohne ihn herauszugeben. Gedacht für das
 * Verpacken beim Einrichten eines Passkeys — für alles andere gibt es `sealWithVault`.
 */
export function withVaultKey<T>(action: (key: Uint8Array) => T): T {
  return action(requireVaultKey());
}

export function wrapDataKey(dataKey: Uint8Array): string {
  return seal(dataKey, requireVaultKey());
}

export function unwrapDataKey(wrapped: string): Uint8Array {
  return open(wrapped, requireVaultKey());
}

export function sealWithVault(data: Uint8Array): string {
  return seal(data, requireVaultKey());
}

export function openWithVault(envelope: string): Uint8Array {
  return open(envelope, requireVaultKey());
}
